// extracted by mini-css-extract-plugin
export default {"wrapper":"SignOutView_wrapper__8mwyW","messageRow":"SignOutView_messageRow__lo2dx"};